module.exports = __webpack_public_path__ + "img/pengin2.98531bf9.jpg";